var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-chip',{staticClass:"min-width-120",attrs:{"color":"warning","icon":"mdi-timer-sand-complete","iconColor":"black","text-color":"black"}},[_vm._v(" "+_vm._s(_vm.$t("commons.status.pending"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }